import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectNotifications = createSelector(
  [(store: RootState) => store.notificationsList.notificationsList],
  (data) => data
);
